import { render, staticRenderFns } from "./CuadraturaCurso.vue?vue&type=template&id=1a4932c8&"
import script from "./CuadraturaCurso.vue?vue&type=script&lang=js&"
export * from "./CuadraturaCurso.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports